<template>
  <div>
    <div class="vx-row">
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div class="vx-col w-full">
        <vx-card title="Creating a new order - search product catalogue to start" >
          <template slot="actions">

            <vs-button v-can="'create-order'" icon-pack="feather" icon="icon-arrow-left" @click="refreshData" class="mr-4" color="primary" type="border">
              Back to orders
            </vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
              <form autocomplete="off">
            <vs-table id="sample_list" v-can="'view-order'"  :data="staff"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="header">

                <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                          v-model="filters['search']"
                          class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
                <span v-if="isHaveCreditAccount" class="text-danger text-lg	">Available credit ({{__accountCurrency()}}):  <b>{{creditDetails.available_credit}}</b></span>
                <vs-button id="place_order" :disabled="cartItems.length === 0" v-can="'create-order'" icon-pack="feather" icon="icon-shopping-cart" @click="onClickPlaceOrder" class="mr-12" color="primary" type="filled">
                  View cart ({{cartItems.length}} Items)
                </vs-button>
              </template>

              <template slot="thead">
                <vs-th width="15%" sort-key="formulation_code">PRODUCT CODE</vs-th>
                <vs-th width="20%" sort-key="name">NAME</vs-th>
                <vs-th width="15%">QUANTITY (KG)</vs-th>
                <!--                <vs-th width="15%">PRICE TYPE</vs-th>-->
                <vs-th width="15%" class="">UNIT PRICE Excl VAT (KG/{{__accountCurrency()}})</vs-th>
                <vs-th width="15%" class="">TOTAL PRICE Excl VAT ({{__accountCurrency()}})</vs-th>
                <vs-th width="20%" class="" v-can="'edit-order'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].formulation_code">
                    {{ data[indextr].formulation_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name}}
                  </vs-td>

                  <vs-td :data="data[indextr].quantity">
                    <ValidationProvider v-if="data[indextr].type === 'List'" :vid="indextr + 'quantity' " :name="indextr + 'quantity'" :rules="'moq:'+data[indextr].min_order_quantity" v-slot="{ errors }">
                    <vs-input v-on:input="onChangeQty(data[indextr],  indextr)"  type="text" v-model="data[indextr].quantity" class="w-full"
                                :name="indextr+'quantity'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                    <span class="ml-2" v-if="['Contract', 'Bespoke'].includes(data[indextr].type)"> {{ data[indextr].quantity || '' }} </span>
                  </vs-td>

<!--                  <vs-td :data="data[indextr].type">-->
<!--                    <v-select-->
<!--                      @input="priceCalculator(data[indextr], indextr)"-->
<!--                      :append-to-body="true"-->
<!--                      :closeOnSelect="true"-->
<!--                      :clearable="true"-->
<!--                      v-model="data[indextr].type"-->
<!--                      :options="optionFactory(data[indextr])"-->
<!--                      :dir="$vs.rtl ? 'rtl' : 'ltr'"/>-->
<!--                  </vs-td>-->

                  <vs-td :data="data[indextr].unit_price">
                    {{data[indextr].unit_price}}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{data[indextr].quantity ? (Number(data[indextr].unit_price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                  </vs-td>

                  <vs-td v-can="'edit-order'">
                    <div class="vx-row">
<!--                      <vx-tooltip class="mr-2" text="Add to cart" position="right">-->
<!--                        <vs-button :disabled="!(data[indextr].quantity && data[indextr].type &&  Number(data[indextr].quantity) >= Number(data[indextr].min_order_quantity))" :id="'add_button'+''+ indextr" v-if="!checkSampleInCart(data[indextr])" @click.native="onClickAddToCart(data[indextr], indextr)"-->
<!--                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus">Add</vs-button>-->
<!--                      </vx-tooltip>-->
<!--                      <vx-tooltip class="mr-2" text="Update" position="left">-->
<!--                        <vs-button :id="'update_button'+''+ indextr" v-if="checkSampleInCart(data[indextr])" @click.native="onClickUpdateFromCart(data[indextr].id, indextr)"-->
<!--                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit">Update</vs-button>-->
<!--                      </vx-tooltip>-->
                      <vx-tooltip class="mr-2" text="Remove cart" position="left">
                        <vs-button :id="'remove_button'+''+ indextr" v-if="checkSampleInCart(data[indextr])" @click.stop="onClickRemoveFromCart(data[indextr].id, indextr)"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="['Contract', 'Bespoke'].includes(data[indextr].type)" text="Add/Update price tiers" position="top">
                        <vs-button :id="'add_button'+''+ indextr" @click.native="onClickCalculatePrice(data[indextr], indextr)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus">Price tiers</vs-button>
                      </vx-tooltip>

                    </div>
                  </vs-td>

                </vs-tr>
                <vs-tr>
                  <vs-td style="font-weight: bolder">Total ({{__accountCurrency()}})</vs-td>
                  <vs-td></vs-td>
                  <vs-td></vs-td>
                  <vs-td></vs-td>
                  <vs-td style="font-weight: bolder">{{totalCalculator()}}</vs-td>
                  <vs-td></vs-td>
                </vs-tr>
              </template>


            </vs-table>
              </form>
            </ValidationObserver>

          </div>
        </vx-card>
      </div>
    </div>
    <create-customer-sample-order-pop-up v-bind:creditDetails="creditDetails" ref="createCustomerSampleOrderPopUp"/>
    <customer-credit-check-pop-up
      v-on:openCreditLimitRequest="openCreditLimitRequest"
      v-on:refreshData="refreshData"
      v-on:onlyRefreshData="onlyRefreshData"
      ref="customerCreditCheckPopUp"/>
    <create-customer-account-limit-request-pop-up ref="createCustomerAccountLimitRequestPopUp" />
    <calculate-product-price-pop-up ref="calculateProductPricePopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Calculations from '@/mixins/Calculations'
  import CreateCustomerSampleOrderPopUp from '@/components/popups/customer/product-orders/CreateCustomerSampleOrderPopUp'
  import CustomerCreditCheckPopUp from '@/components/popups/customer/product-orders/CustomerCreditCheckPopUp'
  import CreateCustomerAccountLimitRequestPopUp from '@/components/popups/customer/account-limit-request/CreateCustomerAccountLimitRequestPopUp'
  import CalculateProductPricePopUp from "@/components/popups/customer/product-orders/CalculateProductPricePopUp";

  const CustomerRepository = RepositoryFactory.get('customer')

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: '',
        cartItems: [],
        creditDetails: {},
        isHaveCreditAccount: false
      }
    },
    components: {
      'v-select': vSelect,
      CreateCustomerSampleOrderPopUp,
      CustomerCreditCheckPopUp,
      CreateCustomerAccountLimitRequestPopUp,
      CalculateProductPricePopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages, Calculations],
    async mounted () {
      this.customerId = this.$route.params.id
      await this.getCreditDetails()
    },
    methods: {
      async refreshData () {
        await this.loadProductCart()
        this.$emit('back')
      },
      async onlyRefreshData() {
        await this.loadProductCart()
      },
      async openCreditLimitRequest() {
        await this.$refs.createCustomerAccountLimitRequestPopUp.openPopup()
      },
      async getCreditDetails() {
        try {
          const {data} = await CustomerRepository.getCustomerAccountCredit()
          this.creditDetails = data.data
          this.isHaveCreditAccount = true
        } catch (e) {
          this.isHaveCreditAccount = false
        }
      },
      async loadProductCart() {

        try {
          await this.$vs.loading({
            container: '#sample_list',
            scale: 0.45
          })
          const {data} = await CustomerRepository.getListOfProductCatalogue(this.filterQuery)
          await this.getItemsInItemsCart()
          this.staff =  data.data.map((n) => {
            n.unit_price = ''
            return n
          })

          if (!!this.filters['search']) {
            this.staff = this.staff.map((n) => {
              const second =  this.cartItems.find((m) => n.id === m.formulation_id )
              if(!!second) {
                n.quantity = second.quantity
                n.unit_price = second.price
              }
              return n
            })
          } else {
            let staff_arr = this.staff
            staff_arr = staff_arr.map((n) => {
              const second =  this.cartItems.find((m) => n.id === m.formulation_id )
              if(!!second) {
                n.quantity = second.quantity
                n.unit_price = second.price
              }
              return n
            })
            this.staff = staff_arr.filter((n) => !!n.quantity)
          }


        } catch (e) {
          console.log(e)
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#sample_list > .con-vs-loading')
      },

      async onClickAddToCart(data, indextr) {
        await this.$vs.loading({
          container: `#sample_list`,
          scale: 0.45
        })
        try {
          const payload = {}
          payload.customer_id = this.customerId
          payload.formulation_id = data.id
          payload.quantity = data.quantity
          payload.price = (Number(data.unit_price)).toFixed(2)
          payload.type = data.type

          await CustomerRepository.addFormulationsToProductCart(payload)
          await this.getItemsInItemsCart()
          this.filters =  {}
          this.showSuccessMessage('Product added')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#sample_list > .con-vs-loading`)
      },
      async onClickRemoveFromCart(id, indextr) {
        await this.$vs.loading({
          container: `#remove_button${indextr}`,
          scale: 0.45
        })
        try {
          const search = this.cartItems.find((n) => n.formulation_id === id )
          await CustomerRepository.removeFormulationsFromProductCart(search.id)
          await this.loadProductCart()
          this.showSuccessMessage('Product removed')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#remove_button${indextr} > .con-vs-loading`)
      },
      async onClickUpdateFromCart(data, indextr) {
        await this.$vs.loading({
          container: `#sample_list`,
          scale: 0.45
        })
        try {
          const search = this.cartItems.find((n) => n.formulation_id === data.id )
          const payload = {quantity: data.quantity, price: data.unit_price}
          await CustomerRepository.updateFormulationsQuantityInProductCart(search.id, payload)
          await this.loadProductCart()
          this.filters =  {}
          this.showSuccessMessage('Product qty updated')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#sample_list > .con-vs-loading`)
      },

      async onClickCalculatePrice(data, index) {
        if(data.price.length === 0) {
          alert('error in price tiers')
          return
        }
        await this.$refs.calculateProductPricePopUp.openPopup(data, index)
      },

      async getItemsInItemsCart() {
        await this.$vs.loading({
          container: '#place_order',
          scale: 0.45
        })
        try {
          const {data} = (await CustomerRepository.getItemsInProductCart()).data
          this.cartItems = data
        }catch (e) {
          console.log(e)
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#place_order > .con-vs-loading')
      },
      async onClickPlaceOrder() {
        await this.$refs.createCustomerSampleOrderPopUp.openPopup()
      },

      filterQueryUpdate (){
        this.loadProductCart()
      },

      handleChangePage(page) {
        this.page=page;
        this.loadProductCart()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadProductCart()
        }
      },
      onClickStatusChangeConfirm(id, status) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.onChangeSampleOrderStatus,
          parameters: [id, status]
        })
      },
      async onChangeSampleOrderStatus(params){
        this.$vs.loading()
        try {
          await CustomerRepository.statusChangeCustomerSampleOrders(params[0], params[1])
          this.showSuccessMessage('Status change successfully!')
          await this.loadProductCart()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      checkSampleInCart: function (object) {
        const arr = this.cartItems.filter((n) => n.formulation_id === object.id)
        return arr.length > 0
      },
      priceCalculator(data, index) {
        if (Number(data.contract_price) > 0) {
          this.staff[index].price = data.contract_price
          this.staff[index].type = 'contract'
          return data.contract_price
        } else {
          this.staff[index].price = data.price
          this.staff[index].type = 'price'
          return data.price
        }
        // this.staff[index].price = data.type === 'list' ? data.list_price
        //   : data.type === 'contract' ? data.contract_price
        //     : null
      },
      optionFactory(data) {
        const arr = []
        if(Number(data.contract_price) > 0) { arr.push('contract') }
        if(Number(data.list_price) > 0) { arr.push('list') }
        return arr
      },
      totalCalculator() {
        let total = 0;
        this.staff.forEach((m) => {
          if (!!m.quantity) {
            total = total + Number(m.unit_price) * Number(m.quantity)
          }

        })
        return total.toFixed(2)
      },
      onChangeQty(row_data, index) {
        let data = {}
        Object.assign(data, row_data)
        if (Number(data.quantity) < Number(data.min_order_quantity) || !data.quantity) {
          return null
        }
        data.type = data.type === 'List' ? 'price' : 'contract'
        if(data.type === 'price') {
          let unit_price = this.calculateProductListPrice(data.pe_g, data.quantity, data.fx_rate)
          this.staff[index].unit_price =  unit_price
          data.unit_price =  unit_price
        }
        const find = this.cartItems.find((m) => m.formulation_id === data.id)
        if(find) {
          this.updateCart(data, index, this)
        } else {
          this.addCart(data, index, this);
        }
      },
      addCart: _.debounce( async (data, index, vm) => {

        if (!vm.isCanAddOrderWithCredit()) {
          await vm.openCreditCheckPopUp()
          return null
        }
        await vm.onClickAddToCart(data, index)
      }, 1500),
      updateCart: _.debounce( async (data, index, vm) => {

        if (!vm.isCanAddOrderWithCredit()) {
          await vm.openCreditCheckPopUp()
          return null
        }
        await vm.onClickUpdateFromCart(data, index)
      }, 1500),
      isCanAddOrderWithCredit() {
        if(this.creditDetails.account_type === 'proforma') {
          return true
        }
        const cart_total = this.totalCalculator()
        const available_credit = this.creditDetails.available_credit
        return Number(cart_total) < Number(available_credit)
      },
      async openCreditCheckPopUp() {
        await this.$refs.customerCreditCheckPopUp.openPopup()
      }

    },
    watch : {
      page(){
        this.loadProductCart()
      }
    },
    computed: {

    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
  table td {
    vertical-align: top;
    min-width: 140px;
    padding-bottom: .8rem;
    word-break: break-all;
    }

</style>
